import { render } from "./PageComponent.vue?vue&type=template&id=7a2edebe&ts=true"
import script from "./PageComponent.vue?vue&type=script&lang=ts"
export * from "./PageComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__